import { createRoute } from '@tanstack/react-router';
import { RoutesMap } from '@Router/router.types';
import { routesModel } from '@Router/router.consts';
import { beforeLoadGeneral } from '@Router/middleware';
import { DnbEmbeddedIntro } from '@Pages/passwordless/dnbEmbeddedIntro/DnbEmbeddedIntro';
import { rootRoute } from './rootRoute';

const DnbEmbeddedIntroRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.DNB_EMBEDDED_INTRO].path,
  beforeLoad: () => {
    beforeLoadGeneral({
      page: RoutesMap.DNB_EMBEDDED_INTRO,
      shouldUpdateServerNavStack: false,
      shouldAvoidAuthCheck: true,
    });
  },
  component: () => <DnbEmbeddedIntro />,
});

export const dnbEmbeddedIntroRoutes = [DnbEmbeddedIntroRoute];
